"use strict";

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/slice");

var _Array$from = require("@babel/runtime-corejs3/core-js/array/from");

var _getIteratorMethod = require("@babel/runtime-corejs3/core-js/get-iterator-method");

var _Symbol = require("@babel/runtime-corejs3/core-js/symbol");

var _Array$isArray = require("@babel/runtime-corejs3/core-js/array/is-array");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createFetchers = createFetchers;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/json/stringify"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));

var _lodash = require("lodash");

var _qs = _interopRequireDefault(require("qs"));

var _login = require("../login");

var _apiError = require("./api-error");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context5, _context6; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context5 = ownKeys(Object(source), !0)).call(_context5, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context6 = ownKeys(Object(source))).call(_context6, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { _Object$defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof _Symbol !== "undefined" && _getIteratorMethod(iter) != null || iter["@@iterator"] != null) return _Array$from(iter); }

function _arrayWithoutHoles(arr) { if (_Array$isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function handleResponse(response, _ref) {
  var _context, _context2;

  var _ref$extraSuccessCode = _ref.extraSuccessCodes,
      extraSuccessCodes = _ref$extraSuccessCode === void 0 ? [] : _ref$extraSuccessCode,
      isLoginRedirect = _ref.isLoginRedirect,
      backUrl = _ref.backUrl;

  if (response.success === false || response !== null && response !== void 0 && response.code && !(0, _includes.default)(_context = (0, _concat.default)(_context2 = [0]).call(_context2, _toConsumableArray(extraSuccessCodes))).call(_context, response.code)) {
    var isLoginRedirectRequired = (response === null || response === void 0 ? void 0 : response.code) === _apiError.EErrorCode.LoginRequired;

    if (isLoginRedirect && isLoginRedirectRequired) {
      (0, _login.gotoLogin)(backUrl);
    }

    throw new _apiError.APIError({
      code: response === null || response === void 0 ? void 0 : response.code,
      message: response.message || response.info,
      response: response
    });
  }

  return response;
}

function handleRedirect(response, _ref2) {
  var isLoginRedirect = _ref2.isLoginRedirect,
      backurl = _ref2.backUrl;

  if (response.redirected) {
    if (response.url.match(/\/member\/login/) && isLoginRedirect) {
      (0, _login.gotoLogin)(backurl);
      throw new _apiError.APIError({
        code: _apiError.EErrorCode.LoginRequired,
        message: '请先登录'
      });
    }
  }

  return response;
}

function prepareBody(body) {
  if (!body) {
    return {};
  }

  if (body instanceof FormData) {
    return {
      body: body
    };
  }

  if (typeof body === 'string') {
    return {
      type: 'application/x-www-form-urlencoded',
      body: body
    };
  }

  return {
    type: 'application/json',
    body: (0, _stringify.default)(body)
  };
}

function prepareFetchOptions(options) {
  var _prepareBody = prepareBody(options.body),
      type = _prepareBody.type,
      body = _prepareBody.body;

  return _objectSpread(_objectSpread({}, options), {}, {
    headers: _objectSpread(_objectSpread({
      Accept: 'application/json'
    }, type && {
      'Content-Type': type
    }), options.headers),
    body: body
  });
}

function createFetchers() {
  var factoryOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onError = factoryOptions.onError;

  var createFetcher = function createFetcher(method) {
    return function (fetchOptions, extraOptions) {
      var _context3;

      var url = fetchOptions.url,
          _fetchOptions$timeout = fetchOptions.timeout,
          timeout = _fetchOptions$timeout === void 0 ? factoryOptions.timeout : _fetchOptions$timeout,
          params = fetchOptions.params;
      var realUrl = (0, _concat.default)(_context3 = "".concat(url)).call(_context3, params ? "?".concat(_qs.default.stringify(params)) : '');

      var mergedExtraOptions = _objectSpread({
        extraSuccessCodes: [],
        isLoginRedirect: true
      }, extraOptions);

      return _promise.default.race((0, _lodash.compact)([fetch(realUrl, _objectSpread({
        method: method,
        mode: 'cors',
        credentials: 'include'
      }, prepareFetchOptions(fetchOptions))).then(function (response) {
        return handleRedirect(response, mergedExtraOptions);
      }) // TODO: 支持自定义格式的响应
      .then(function (response) {
        return response.json();
      }).then(function (response) {
        return handleResponse(response, mergedExtraOptions);
      }), timeout && (0, _utils.rejectAfter)(timeout)])).catch(function (err) {
        onError === null || onError === void 0 ? void 0 : onError(err);
        throw err;
      });
    };
  };

  return {
    getFetch: createFetcher('GET'),
    postFetch: createFetcher('POST')
  };
}